import React from 'react';
import AlertBaseForm from './MetricsMetasearch';
import {useParams} from "react-router-dom";
import {APP_ALERT_CENTER_API_ENDPOINT} from "../../../../constants/api_urls";
import { getUserToken } from "utils/functions/userToken";

const AlertMetasearchTripadvisorMetaForm = ({alertData, actionType, onClose, showSnackbar, refreshData}) => {

    const { idaccount } = useParams();
    const availableSegments = ["DEVICE", "MARKET"];
    let method = 'POST';
    let apiActionEndpoint = '';
    const apiEndpoint = `${APP_ALERT_CENTER_API_ENDPOINT}/api/alert-center-metrics/tripadvisor-meta/metrics-list`;
    if(actionType === 'edit') {
        method = 'PUT';
        apiActionEndpoint = `${APP_ALERT_CENTER_API_ENDPOINT}/api/alert-center-metrics/tripadvisor-meta/edit/${idaccount}/` + alertData.id;
    }
    else {
        apiActionEndpoint = `${APP_ALERT_CENTER_API_ENDPOINT}/api/alert-center-metrics/tripadvisor-meta/add/${idaccount}`;
    }
    const jwtToken = getUserToken();

    const submitTripadvisorMetaAlert = (requestBody) => {
        fetch(apiActionEndpoint, {
            method: method,
            headers: {
                'Authorization': `Bearer ${jwtToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody),
        })
            .then((response) => {
                if (!response.ok) { // Check if the response is not OK (status code outside 200-299)
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then((result) => {
                showSnackbar('Alert saved successfully');
                if (refreshData) {
                    refreshData();
                }
                onClose();
            })
            .catch((error) => {
                console.error('Error saving alert:', error); // Log the error for debugging
                showSnackbar('Error saving alert' + error.message, 'error');
            });
    };

    return (
        <div>
            <AlertBaseForm
                apiEndpoint={apiEndpoint}
                alertData={alertData}
                jwtToken={jwtToken}
                submitCallback={submitTripadvisorMetaAlert}
                availableSegments={availableSegments}
                onClose={onClose}
            />
        </div>
    );
};

export default AlertMetasearchTripadvisorMetaForm;
